import { CmsMeta } from '../cms/cmsMeta';
import './ContentCard.css';
import { ReactNode } from 'react';

type ContentCardProps = {
	className?: string;
	title?: string;
	children: ReactNode;
};
export function ContentCard({ className, title, children }: ContentCardProps): JSX.Element {
	return (
		<content-card class={className}>
			{title ? <h2>{title}</h2> : null}
			{children}
		</content-card>
	);
}

export const cmsMeta: CmsMeta = {
	description: 'A white card with page padding. The usual wrapper for prose - most text on a page sits in one.',
	example: [
		'ContentCard',
		{ index: 0 },
		['CmsHtml', { index: 0, content: '<h1>Cookies</h1><p>Unsere Website verwendet Cookies.</p>' }],
	],
};
